import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PageHeader, { EmptyState } from "@/components/PageHeader";
import StatusChip from "@/components/StatusChip";
import { toast } from "sonner";
import RecordActions from "@/components/RecordActions";

import { Truck } from "@phosphor-icons/react";

export default function Shipping() {
  const [rows, setRows] = useState([]);

  const load = async () => {
    try { const { data } = await api.get("/shipping/vendors"); setRows(data); }
    catch { toast.error("Load failed"); }
  };
  useEffect(() => { load(); }, []);

  const testConn = async (id) => {
    try { await api.post(`/shipping/vendors/${id}/test`); toast.success("Connected (MOCKED)"); load(); }
    catch { toast.error("Failed"); }
  };

  const toggleActive = async (v) => {
    try { await api.patch(`/shipping/vendors/${v._id}`, { active: !v.active }); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div data-testid="shipping-page" className="page-fade">
      <PageHeader eyebrow="Module" title="Shipping vendors" description="Configure shipping partners. Live courier API integrations are MOCKED — swap credentials in production." tint="teal" icon={Truck} />
      {rows.length === 0 ? (
        <div className="card-soft"><EmptyState icon={Truck} title="No shipping vendors" description="Configure your first shipping partner to enable dispatch." /></div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 stagger">
          {rows.map((v) => (
            <div key={v._id} className="card-elevated" data-testid={`vendor-card-${v.slug}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="label-eyebrow">{v.domestic && "Domestic"}{v.domestic && v.international && " · "}{v.international && "International"}</div>
                  <div className="display-3 mt-1">{v.name}</div>
                </div>
                <StatusChip value={v.connected ? "ok" : v.active ? "pending" : "cancelled"}/>
              </div>
              <div className="mt-5 space-y-1 text-sm">
                <Row label="COD" value={v.cod ? "Yes" : "No"}/>
                <Row label="Reverse pickup" value={v.exchange_pickup ? "Yes" : "No"}/>
                <Row label="Est. days" value={v.estimated_days || "—"}/>
                <Row label="Delivery rate" value={`${((v.performance?.delivery_rate || 0) * 100).toFixed(1)}%`}/>
                <Row label="Avg delay" value={`${v.performance?.avg_delay_days || 0} d`}/>
              </div>
              <div className="flex gap-2 mt-6">
                <button onClick={()=>testConn(v._id)} className="btn-ghost flex-1 btn-sm" data-testid={`vendor-test-${v.slug}`}>Test connection</button>
                <button onClick={()=>toggleActive(v)} className="btn-ghost btn-sm px-3" data-testid={`vendor-toggle-${v.slug}`}>{v.active ? "Disable" : "Enable"}</button>
                <RecordActions entity="shipping_vendors" record={v} frozen={["slug"]} onChanged={load} />
              </div>
              <p className="mt-4 text-[11px] text-[color:hsl(var(--warning))]">Live courier API integration is MOCKED.</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between border-b border-border/60 py-2 last:border-b-0">
      <span className="label-eyebrow">{label}</span>
      <span className="text-sm tabular">{value}</span>
    </div>
  );
}
